import './styles.css';

import React from 'react';
import PropTypes from "prop-types";


const InformationLabelListContent = (props) => {

    const { informationLabelListStrongContent, informationLabelListStrongCount } = props;

    return (
        <div className="information-label-list-content">
            {
                informationLabelListStrongCount ?
                    <strong>{informationLabelListStrongCount}&nbsp;</strong>
                    :
                    null
            }
            {
                informationLabelListStrongContent ?
                    <strong>{props.informationLabelListStrongContent}</strong>
                    :
                    null
            }
            {props.informationLabelListContent}
        </div>
    );

};

InformationLabelListContent.propTypes = {
    informationLabelListStrongContent: PropTypes.string.isRequired,
    informationLabelListContent: PropTypes.string.isRequired,
    informationLabelListStrongCount: PropTypes.string.isRequired
};


InformationLabelListContent.defaultProps ={

};

export default InformationLabelListContent;



// WEBPACK FOOTER //
// ./src/components/InformationLabelListContent/InformationLabelListContent.js